import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#F9F8F6] pt-24 pb-12 px-4">
      <Card className="max-w-4xl mx-auto border-0 shadow-xl">
        <CardHeader>
          <CardTitle className="text-3xl font-bold text-[#1A3636]">Aviso de Privacidad</CardTitle>
          <p className="text-gray-500">Última actualización: Marzo 2026</p>
        </CardHeader>
        <CardContent className="prose prose-gray max-w-none space-y-6 text-[#333]">
          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">1. Responsable del Tratamiento</h2>
            <p>FindMed, con domicilio en México, es responsable del tratamiento de sus datos personales, de conformidad con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP).</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">2. Datos Personales Recabados</h2>
            <p>Para la prestación de nuestros servicios, recabamos los siguientes datos personales:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Datos de identificación:</strong> Nombre completo, correo electrónico, número telefónico.</li>
              <li><strong>Datos de identificación oficial:</strong> Imagen de la credencial de elector (INE) para verificación de identidad.</li>
              <li><strong>Datos financieros:</strong> Los datos de pago son procesados directamente por Stripe y no son almacenados en nuestros servidores.</li>
              <li><strong>Datos de ubicación:</strong> En caso de solicitar el servicio de emergencia, se recabará su ubicación geográfica para el envío de la unidad.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">3. Finalidades del Tratamiento</h2>
            <p>Sus datos personales serán utilizados para las siguientes finalidades:</p>
            <h3 className="text-lg font-semibold text-[#1A3636]">Finalidades primarias (necesarias):</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Crear y administrar su cuenta de usuario.</li>
              <li>Verificar su identidad para la activación de la membresía.</li>
              <li>Procesar pagos y emitir comprobantes.</li>
              <li>Prestar el servicio de ambulancia de emergencia.</li>
              <li>Enviar notificaciones relacionadas con su membresía (activación, vencimiento, consumo del servicio).</li>
            </ul>
            <h3 className="text-lg font-semibold text-[#1A3636] mt-4">Finalidades secundarias:</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Enviar información sobre promociones o nuevos servicios.</li>
              <li>Realizar encuestas de satisfacción.</li>
              <li>Generar estadísticas internas de uso del servicio.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">4. Transferencia de Datos</h2>
            <p>Sus datos personales podrán ser transferidos a:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Stripe:</strong> Para el procesamiento de pagos.</li>
              <li><strong>SendGrid:</strong> Para el envío de comunicaciones por correo electrónico.</li>
              <li><strong>Autoridades competentes:</strong> Cuando sea requerido por ley.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">5. Derechos ARCO</h2>
            <p>Usted tiene derecho a Acceder, Rectificar, Cancelar u Oponerse al tratamiento de sus datos personales (Derechos ARCO). Para ejercer estos derechos, envíe un correo electrónico a <strong>contacto@findmed.com.mx</strong> con los siguientes datos:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Nombre completo del titular.</li>
              <li>Descripción clara del derecho que desea ejercer.</li>
              <li>Copia de identificación oficial.</li>
            </ul>
            <p>Daremos respuesta a su solicitud en un plazo máximo de 20 días hábiles.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">6. Medidas de Seguridad</h2>
            <p>Implementamos medidas de seguridad administrativas, técnicas y físicas para proteger sus datos personales contra daño, pérdida, alteración, destrucción o uso no autorizado, incluyendo:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Encriptación de datos sensibles.</li>
              <li>Conexiones seguras (HTTPS/SSL).</li>
              <li>Control de acceso restringido a datos personales.</li>
              <li>Almacenamiento seguro de contraseñas mediante hash.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">7. Uso de Cookies</h2>
            <p>Nuestro sitio web utiliza cookies de sesión necesarias para el funcionamiento de la plataforma. Estas cookies son esenciales para mantener su sesión activa y no se utilizan con fines publicitarios.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">8. Modificaciones al Aviso</h2>
            <p>Nos reservamos el derecho de modificar este Aviso de Privacidad en cualquier momento. Las modificaciones estarán disponibles en nuestro sitio web.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">9. Contacto</h2>
            <p>Para cualquier consulta relacionada con este Aviso de Privacidad:</p>
            <ul className="list-disc pl-6">
              <li>Email: contacto@findmed.com.mx</li>
              <li>Teléfono: 55 2567 1884</li>
            </ul>
          </section>
        </CardContent>
      </Card>
    </div>
  );
}
